import React, { useState } from "react";
import { Formik } from "formik";
import { addNewAddress } from "../../../../api";
import phones from "../../../../static/phones.json";
import countriesData from "../../../../static/countries.json";
import { initialValues, validate } from "./initForm";
import { validateNumber } from "../../../../utils/validations";
import { useDispatch } from "react-redux";
import { authActions } from "../../../../actions/auth";

import TextFieldV3 from "../../../Inputs/TextFieldv3";
import SelectTypeAddress from "../../../Inputs/SelectTypeAddress";
import Select from "../../../Inputs/Select";
import SelectV2 from "../../../Inputs/Select";
import Button from "../../../Button";
import TextFieldv3 from "../../../Inputs/TextFieldv3";
import styles from "./UploadShippingModal.module.scss";
import homeIcon from "../../../../static/icons/house-two.svg";
import closeIcon from "../../../../static/icons/close.svg";

const UploadShippingModal = ({
  onClose,
  submitButtonText = "Save",
  submitButtonColor = "blue",
  isCancelButtonNeed = true,
  onUpdateAddresses,
}) => {
  const [phoneCodes, setPhoneCodes] = useState(phones);
  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState(countriesData);
  const reduxDispatch = useDispatch();

  const searchCountryCode = (query) => {
    setPhoneCodes(phones.filter((item) => item.value.includes(query)));
  };
  const searchCountries = (query) => {
    const q = String(query || "").toLowerCase();
    setCountries(
      countriesData.filter((item) => String(item.value).toLowerCase().includes(q))
    );
  };

  const createNewAddress = (addressInfo) => {
    let city_place_id = "";

    if (cities.length > 0) {
      city_place_id = cities.find(({ value }) => value === addressInfo.city)
        .shortValue;
    } else {
      delete addressInfo.city;
    }

    const totalAddressInfo = {
      ...addressInfo,
      phone: `${addressInfo.countryCode.trim()}${addressInfo.phoneNumber.trim()}`,
      city_place_id,
    };
    onClose();

    reduxDispatch(authActions.startLoading());

    addNewAddress(totalAddressInfo).then(({ response }) => {
      if (response) {
        reduxDispatch(authActions.finishLoading());
        onUpdateAddresses();
      }
    });
  };

  return (
    <div className={styles.Modal}>
      <Formik
        initialValues={initialValues}
        onSubmit={createNewAddress}
        validate={(values) => validate(values, cities)}
      >
        {({ handleSubmit, errors, touched }) => {
          const isNameError =
            errors.client_full_name && touched.client_full_name;
          const isPhoneError = errors.phoneNumber && touched.phoneNumber;
          return (
            <form onSubmit={handleSubmit}>
              <div className={styles.header}>
                <h2 className={styles.title}>EDIT ADDRESS</h2>
                <p className={styles.subtitle}>Update your shipping address details below.</p>
              </div>

              <div className={styles.home}>
                <SelectTypeAddress
                  options={[{ value: "Home" }, { value: "Work" }]}
                  name="alias"
                  type="text"
                  placeholder="Home"
                  variant="underline"
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Receiver name</label>
                <TextFieldV3
                  name="client_full_name"
                  type="text"
                  placeholder="Type here..."
                  variant="voucher"
                  bare
                />
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Phone number</label>
                <div className={styles.phoneLine}>
                  <div className={styles.countryCode}>
                    <SelectV2
                      options={phoneCodes}
                      name="countryCode"
                      type="text"
                      placeholder="00"
                      variant="voucher"
                      isAutocomplete
                      onAutocomplete={(query) => searchCountryCode(query)}
                      suppressErrorPlaceholder
                      validateSymbols={(val) => validateNumber(val, 10)}
                    />
                  </div>
                  <div className={styles.phoneNumber}>
                    <TextFieldV3
                      name="phoneNumber"
                      type="text"
                      placeholder="Type here..."
                      variant="voucher"
                      bare
                      validateSymbols={(val) => validateNumber(val)}
                    />
                  </div>
                </div>
              </div>
              <div className={styles.field}>
                <label className={styles.label}>Country</label>
                <Select
                  name="country"
                  variant="voucher"
                  isAutocomplete
                  options={countries}
                  onAutocomplete={searchCountries}
                  placeholder="Type here..."
                />
              </div>
              
              <div className={styles.field}>
                <label className={styles.label}>Address</label>
                <Select
                  isAutocomplete
                  name="address"
                  variant="voucher"
                  options={[]}
                  isTypeAndDropdown
                  placeholder="Type here..."
                />
              </div>
              
              <div className={styles.cityZipRow}>
                <div className={styles.cityField}>
                  <label className={styles.label}>City</label>
                  <Select
                    isAutocomplete
                    name="city"
                    variant="voucher"
                    options={cities}
                    isTypeAndDropdown
                    setCity={setCities}
                    placeholder="San Francisco"
                  />
                </div>
                <div className={styles.zipField}>
                  <label className={styles.label}>Zip code</label>
                  <TextFieldV3
                    name="postal_code"
                    type="text"
                    placeholder="Type here..."
                    variant="voucher"
                    bare
                  />
                </div>
              </div>

              <div className={styles.field}>
                <label className={styles.label}>Notes for courier (optional)</label>
                <TextFieldV3
                  huge="true"
                  name="notes"
                  type="text"
                  placeholder="Type here..."
                  variant="voucher"
                  bare
                />
              </div>
              <div className={styles.buttons}>
                <Button
                  className={styles.saveButton}
                  type="submit"
                  size="large"
                  color="blue"
                >
                  SAVE ADDRESS
                </Button>
                {isCancelButtonNeed && (
                  <Button
                    type="button"
                    size="large"
                    onClick={onClose}
                    className={styles.cancelButton}
                  >
                    Cancel
                  </Button>
                )}
              </div>
            </form>
          );
        }}
      </Formik>
    </div>
  );
};

export default UploadShippingModal;
